import {RECOVERY_PREPARATION_STATE} from '@/constants/enums';
import {createNewJsonObject} from '@/libs/appHelper';

import * as PRESSURE_CONSTANT from '../constant/pressureContentConstant';

// eslint-disable-next-line import/prefer-default-export
export const ConvertSequenceToBackendParam = (fullOpeartionsParam, defaultPressureTemplate) => {
  const operations = createNewJsonObject(fullOpeartionsParam.Operations);
  const newOperations = [];
  const opearionsLength = operations.length;
  for (let i = 0; i < opearionsLength; i++) {
    const operation = operations[i];
    const operationsPressureType = operation.PressureState.PressureType;
    const operationsPressureParam = operation.PressureState.PressureConfig[operationsPressureType];
    const operationPressure = createNewJsonObject(defaultPressureTemplate);
    operationPressure.SequenceParams.PressureType = operationsPressureType;
    operationPressure.SequenceParams.TargetPressure = operationsPressureParam;
    operationPressure.Active = operation.Active;
    operation.PressureState.ChipTiming = operation.SequenceParams;
    if (operation.PressureState.PressureType === PRESSURE_CONSTANT.PRESSURE_TYPE.LO) {
      operation.SequenceParams = operation.SequenceParams.Lo;
    } else {
      operation.SequenceParams = operation.SequenceParams.Hi;
    }
    operation.RecoveryPreparationState = RECOVERY_PREPARATION_STATE.NONE;
    newOperations.push(operationPressure);
    newOperations.push(operation);
  }
  fullOpeartionsParam.Operations = newOperations;
  return fullOpeartionsParam;
};
